<template>
  <div class="main-content">
    <scrollTop>
      <i class="icon-fa icon-fa-arrow-up"></i>
    </scrollTop>
    <div class="card">
      <div class="card-header">
        <h5>Отчет за период</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="showRecords">
          <div class="row">
            <div class="col-md-6">
              <div class="flex">
                <div>
                  <p>Начало периода</p>
                  <DateSelect ref="start_date"
                              :dateRange="dateRange"
                              :disabled="!!dateRange"
                              :selectedDate="periodDates.start"/>
                </div>
                <div>
                  <p>Конец периода</p>
                  <DateSelect ref="end_date"
                              :selectedDate="periodDates.end"/>
                </div>
              </div>
              <div class="mt-2">
                <label><input type="checkbox" v-model="showRejectedOrders"/> показать отмененные заявки</label>
              </div>
            </div>
            <div class="col-md-6">
              <template v-if="!allowedDivisions">
                <div class="alert alert-warning">
                  У Вас нет доступных дивизионов для просмотра отчета.
                  <p>Обратитесь к администратору</p>
                </div>
              </template>
              <template v-else>
                <select @change="updateRunners" v-model="selectedDivision" class="form-control">
                  <option :value="0">Все дивизионы</option>
                  <option v-for="div in divisionList" :value="div.id">
                    {{ div.title}}
<!--                    {{ div.cities[0].city && div.cities[0].city.name || 'Почта' }}-->
                  </option>
                </select>
                <select v-model="selectedRunner" class="form-control">
                  <option :value="0">Все курьеры</option>
                  <option v-for="(runner, id) in divisionRunners" :value="id">{{ runner }}</option>
                </select>
              </template>
            </div>
          </div>
          <div class="text-right">
            <LoadingButton
              title="Показать"
              type="submit"
              :loading="btnLoading"
              :onClick="showRecords"
              className="btn btn-info m-t-10"/>
          </div>
        </form>
      </div>
    </div>

    <template v-if="btnLoading">
      <div class="card">
        <div class="card-body">
          <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="report">

        <div class="card">
          <div class="card-header">
            <h5>Расходы</h5>
          </div>
          <div class="card-body">
            <template v-if="!report.expenses || !report.expenses.length">
              <div class="alert alert-info">
                <p>Расходы не найдены</p>
              </div>
            </template>
            <template v-else>
              <table class="table table-sm table-hover table-striped">
                <thead>
                <tr>
                  <th></th>
                  <th>Дивизион</th>
                  <th>Тип расхода</th>
                  <th>Комментарий</th>
                  <th>Сумма</th>
                  <th>Дата</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(exp, index) in report.expenses">
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{
                      !exp.to_division_id ? 'Администрация' :
                        $AllDivisions[exp.to_division_id] &&
                        $AllDivisions[exp.to_division_id].user.name
                    }}
                    <template v-if="exp.to_division_id">
                      ({{
                        ($AllDivisions[exp.to_division_id] &&
                          $AllDivisions[exp.to_division_id].cities &&
                          $AllDivisions[exp.to_division_id].cities[0].city &&
                          $AllDivisions[exp.to_division_id].cities[0].city
                            .name) ||
                        "Не указан"
                      }})
                    </template>
                  </td>
                  <td>{{ expensesTypes[exp.type_id] }}</td>
                  <td>{{ exp.comment }}</td>
                  <td>{{ exp.sum }}</td>
                  <td>{{ printDate(exp.created_at) }}</td>
                </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h5>Инкассации</h5>
          </div>
          <div class="card-body">
            <template v-if="!report.incomes || !report.incomes.length">
              <div class="alert alert-info">
                <p>Инкассаций не найдено</p>
              </div>
            </template>
            <template v-else>
              <table class="table table-sm table-striped">
                <thead>
                <tr>
                  <th>От кого</th>
                  <th>Кому</th>
                  <th>Сумма</th>
                  <th>Валюта</th>
                  <th>Дата</th>
                  <th>Создано</th>
                  <th>Комментарий</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="income in report.incomes" :key="income.id">
                  <td>
                    {{
                      $AllDivisions[income.division_id] &&
                      $AllDivisions[income.division_id].user.name
                    }}
                    ({{
                      ($AllDivisions[income.division_id] &&
                        $AllDivisions[income.division_id].cities &&
                        $AllDivisions[income.division_id].cities[0].city &&
                        $AllDivisions[income.division_id].cities[0].city
                          .name) ||
                      "Не указан"
                    }})
                  </td>
                  <td>
                    {{
                      $AllDivisions[income.to_division_id] &&
                      $AllDivisions[income.to_division_id].user.name
                    }}
                    ({{
                      ($AllDivisions[income.to_division_id] &&
                        $AllDivisions[income.to_division_id].cities &&
                        $AllDivisions[income.to_division_id].cities[0].city &&
                        $AllDivisions[income.to_division_id].cities[0].city
                          .name) ||
                      "Не указан"
                    }})
                  </td>
                  <td>
                    {{ income.sum.toLocaleString("ru-RU") }}
                  </td>
                  <td>{{ $AllCurrencies[income.currency_id].currency }}</td>
                  <td>{{ income.report_date }}</td>
                  <td>{{ printDate(income.created_at) }}</td>
                  <td>{{ income.comment }}</td>
                </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <RunnerReportOrders
              :disableEdit="true"
              :orders="report.orders"
              :runners="runners"
            />
          </div>
        </div>

      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import scrollTop from "../components/scrollTop";
import DateSelect from "@/views/reports/components/DateSelect";
import LoadingButton from "@/components/buttons/LoadingButton";
import RunnerReportOrders from "@/components/reports/RunnerReportOrders";
import Saldo from "@/views/reports/components/Saldo";
import Calculation from "@/views/reports/components/Calculation";
import moment from "moment";

export default {
  components: {
    Saldo,
    Calculation,
    RunnerReportOrders,
    scrollTop,
    DateSelect,
    LoadingButton
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    }
  },
  data() {
    return {
      periodDates: {
        start: moment().startOf('month').format('DD.MM.YYYY'),
        end: moment().format('DD.MM.YYYY'),
      },
      divisionList: {},
      allowedDivisions: null,
      showRejectedOrders: false,
      loadingColor: this.$constants.LOADING_COLOR,
      btnLoading: false,
      selectedDivision: 0,
      selectedRunner: 0,
      allRunners: {},
      divisionRunners: {},
      runners: {},
      expensesTypes: {},
      dayReportData: null,
      reportDate: null,
      dateRange: null,
      report: null
    }
  },
  mounted() {
    this.getRunners();
  },
  methods: {
    moment: function (date, format = "DD.MM.YYYY") {
      if (!date) return;
      return moment(date).format(format);
    },
    async getRunners() {
      const {data} = await api.index('reports/runners');
      if (data.success) {
        this.allRunners = data.runners;
        this.allowedDivisions = data.allowedDivisions;
        this.divisionList = Object.keys(this.$AllDivisions).reduce((acc, divId) => {
          if (this.allowedDivisions === true || data.allowedDivisions.includes(+divId)) {
            acc.push(this.$AllDivisions[divId]);
          }
          return acc;
        }, []);
        this.runners = Object.keys(data.runners).reduce((acc, divId) => {
          const newObj = Object.keys(data.runners[divId]).reduce((ac, rId) => {
            ac[rId] = {name: data.runners[divId][rId]};
            return ac;
          }, {})
          acc = {...acc, ...newObj};
          return acc;
        }, {});
      } else {
        toastr["warning"](data.message || "Ошибка сервера (получение курьеров)");
      }
      if (this.$currentRole !== "admin") {

        this.dateRange = {
          // min: moment().subtract(1, 'months').startOf('month').subtract(1, 'day').format('YYYY-MM-DD'),
          min: moment().set('month', 6).startOf('month').subtract(1, 'day').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD')
        };
      }
    },
    updateRunners() {
      this.selectedRunner = 0;
      this.divisionRunners = {...this.allRunners[this.selectedDivision]};
    },
    async showRecords(e) {
      e.preventDefault();
      if (!this.allowedDivisions) return;
      console.log('show');
      this.btnLoading = true;
      const {data} = await api.post('reports/period', {
        periodDates: {
          start: this.$refs.start_date.date,
          end: this.$refs.end_date.date,
        },
        showRejectedOrders: this.showRejectedOrders,
        divisionId: this.selectedDivision,
        runner: this.selectedRunner
      })
      if (!data.success) {
        toastr["warning"](data.message || "Ошибка сервера");
      } else {
        this.expensesTypes = data.expensesTypes;
        this.dayReportData = data.reportData;
        this.reportDate = data.reportDate;
        this.report = {
          expenses: data.expenses,
          orders: data.orders,
          incomes: data.incomes
        }
      }
      this.btnLoading = false;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 2px;
}
</style>
